// @ts-nocheck
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import { useLocation, Outlet, useNavigate, useOutletContext } from "react-router-dom";
import { useAuth, useUser, useClerk, useOrganization, useOrganizationList } from '@/auth/clerkShim'
import _ from 'lodash';
import { Button } from "@/components/ui/button";
import CreateLeagueModal from "@/components/CreateLeague/create-league-modal";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

function CreateApp() {
  const navigate = useNavigate();
  const { leagueName, league } = useOutletContext() as any;
  const { user, isSignedIn } = useUser();
  const { organization, isLoaded: isLoadedOrg } = useOrganization();
  const { setActive } = useOrganizationList();
  const [memberships, setMemberships] = useState([]);

  const async_getOrganizationMemberships = async () => {
    const memberships = await user.getOrganizationMemberships();
    setMemberships(memberships);
  }

  const onOrganizationChange = (e) => {
    const organizationId = e.target.value;
    setActive({ organization: organizationId });
    const organization = _.find(memberships, { organization: { id: organizationId } });
  }

  useEffect(() => {
    if (isSignedIn) {
      async_getOrganizationMemberships();
    }
  }, [isSignedIn]);

  if (!isSignedIn) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="w-full max-w-3xl">
        <h1>Create New League</h1>
        <div>
          <br />
          <CreateLeagueModal league={league} />
          <button onClick={() => {
            throw new Error('Test error');
          }} className="cursor-pointer">Test Error</button>
        </div>
      </div>
    </div>
  );
}

export default CreateApp;